/**
 * @file
 * Attaches the behaviors for the Menu component.
 */
 !(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.menu = {
    attach(context) {

      const $menus = $('.menu', context);

      // If there are no Menu elements within the context,
      // none of the code below should execute.
      if (!$menus.length) {
        return;
      }

      // Preserve the behavior.
      const self = this;

      $menus.each(function () {
        const $menu = $(this);
        const $toggle = $menu.find('.link__toggle');

        $toggle
          .on('click', function (e) {
            e.preventDefault();
            self.exposeChildren($(this));
          })
          .on('keypress', function (e) {
            const keyCode = e.keyCode ? e.keyCode : e.which;
            if (keyCode === 13) {
              e.preventDefault();
              self.exposeChildren($(this));
            }
          });

        self.initArrowNavigation(this);
      });
    },

    exposeChildren($toggle) {
      const $parent = $toggle.closest('.menu__item');
      const state = $parent.hasClass('expanded');
      $parent
        .toggleClass('expanded', !state)
        .find('> .menu__subnav')
        .attr('aria-expanded', !state ? 'true' : 'false');
    },

    // Roving tabindex arrow-key navigation between top-level menu links.
    initArrowNavigation(menu) {
      const links = Array.from(menu.querySelectorAll(':scope > .menu__item > .menu__link'));

      if (!links.length) {
        return;
      }

      links.forEach((link, i) => {
        link.setAttribute('tabindex', i === 0 ? '0' : '-1');
      });

      menu.addEventListener('keydown', (e) => {
        const currentIndex = links.indexOf(e.target);
        if (currentIndex === -1) {
          return;
        }

        let nextIndex;

        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % links.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (currentIndex - 1 + links.length) % links.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = links.length - 1;
            break;
          default:
            return; // Exit if it's not a navigation key
        }

        e.preventDefault(); // Prevent page scrolling

        links.forEach((link, i) => {
          link.setAttribute('tabindex', i === nextIndex ? '0' : '-1');
        });
        links[nextIndex].focus();
      });
    }

  };
})(jQuery, Drupal);
